import { useEffect, useState } from "react";
import { Shield, Menu, X } from "lucide-react";
import { scrollToSection } from "../lib/scroll";

const links = [
  { label: "Capabilities", target: "#services", id: "capabilities" },
  { label: "Doctrine", target: "#manifesto", id: "doctrine" },
  { label: "K9 Units", target: "#gallery", id: "k9-units" },
  { label: "Intel", target: "#testimonials", id: "intel" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (target) => {
    setOpen(false);
    scrollToSection(target);
  };

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 border-b ${
        scrolled ? "bg-[#08090B]/85 backdrop-blur-xl border-white/10" : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center"
        >
          <img src="/images/logo.png" alt="Frontline K9 Security" className="h-11 w-auto" />
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.target)}
              className="font-mono text-xs uppercase tracking-[0.2em] text-gray-400 hover:text-blue-500 transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-button"
            onClick={() => go("#quote")}
            className="clip-corners bg-blue-600 hover:bg-blue-500 text-white font-mono text-xs uppercase tracking-[0.2em] px-5 py-2.5 transition-colors duration-300"
          >
            Request Deployment
          </button>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-gray-200"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0F1115]/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-link-${l.id}`}
              onClick={() => go(l.target)}
              className="text-left font-mono text-sm uppercase tracking-[0.2em] text-gray-300 hover:text-blue-500"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-cta-button"
            onClick={() => go("#quote")}
            className="clip-corners bg-blue-600 text-white font-mono text-xs uppercase tracking-[0.2em] px-5 py-3 w-fit"
          >
            Request Deployment
          </button>
        </div>
      )}
    </header>
  );
}
